import React, { Component } from 'react';

import { trackPageView } from 'modules';

export default function withPageTracking(WrappedComponent, pageUrl) {
  return class extends Component {
    static displayName = `withPageTracking(${WrappedComponent.displayName || WrappedComponent.name})`;

    componentDidMount() {
      trackPageView(pageUrl);
    }

    render() {
      return <WrappedComponent { ...this.props } />
    }
  };
}



// WEBPACK FOOTER //
// ./src/hoc/withPageTracking.jsx